import { useParams, Navigate } from "react-router-dom";
import { ARTICLES } from "@/src/constants/articles";
import { ArticleHero } from "./(sections)/ArticleHero";
import { ArticleBody } from "./(sections)/ArticleBody";
import { Newsletter } from "@/src/pages/home/(sections)/newsletter/Newsletter";

export function JournalArticlePage() {
    const { id } = useParams<{ id: string }>();
    const article = ARTICLES.find((a) => a.id === id);

    if (!article) return <Navigate to="/journal" replace />;

    return (
        <>
            <ArticleHero article={article} />
            <ArticleBody article={article} />
            <Newsletter />
        </>
    );
}
